<template>
  <!-- Use mouseup.stop to prevent SideLeft/deselectAllSlides function listens to MouseEvent('mouseup'). -->
  <div
    class="aha-right-nav"
    @mouseup.stop
    :class="{
      'powerpoint-addin-sticky': isEnableAddinPowerpoint && rightNavActiveTab
    }"
  >
    <div :data-tab-name="rightNavAllTabs.AI.name">
      <div class="aha-nav-button-container">
        <aha-nav-button
          class="w-full"
          :active="rightNavActiveTab === rightNavAllTabs.AI.name"
          :disabled="isTabDisabled(rightNavAllTabs.AI.name)"
          name="right_nav_button"
          v-aha-emit-action="{ user_input: rightNavAllTabs.AI.name }"
          @click="activeTab(rightNavAllTabs.AI.name)"
          :iconName="rightNavAllTabs.AI.icon"
          :icon-width="rightNavAllTabs.AI.iconWidth"
          :icon-height="rightNavAllTabs.AI.iconHeight"
          :label="$i18nPresenter.t(rightNavAllTabs.AI.name)"
          :lang="getPresenterLocale"
        />
      </div>
    </div>

    <TemplateLibraryNavButton />

    <div class="right-nav__divider-wrapper">
      <div class="right-nav__divider"></div>
    </div>

    <div :data-tab-name="rightNavAllTabs.CONTENT.name">
      <div class="aha-nav-button-container">
        <aha-nav-button
          class="w-full"
          :active="rightNavActiveTab === rightNavAllTabs.CONTENT.name"
          :disabled="isTabDisabled(rightNavAllTabs.CONTENT.name)"
          name="right_nav_button"
          v-aha-emit-action="{ user_input: rightNavAllTabs.CONTENT.name }"
          @click="activeTab(rightNavAllTabs.CONTENT.name)"
          :iconName="rightNavAllTabs.CONTENT.icon"
          :icon-width="rightNavAllTabs.CONTENT.iconWidth"
          :icon-height="rightNavAllTabs.CONTENT.iconHeight"

          :label="$i18nPresenter.t(rightNavAllTabs.CONTENT.name)"
          :lang="getPresenterLocale"
        />
      </div>
    </div>
    <div :data-tab-name="rightNavAllTabs.DESIGN.name">
      <div class="aha-nav-button-container">
        <aha-nav-button
          class="w-full"
          :active="rightNavActiveTab === rightNavAllTabs.DESIGN.name"
          :disabled="isTabDisabled(rightNavAllTabs.DESIGN.name)"
          name="right_nav_button"
          v-aha-emit-action="{ user_input: rightNavAllTabs.DESIGN.name }"
          @click="activeTab(rightNavAllTabs.DESIGN.name)"
          :iconName="rightNavAllTabs.DESIGN.icon"
          :icon-width="rightNavAllTabs.DESIGN.iconWidth"
          :icon-height="rightNavAllTabs.DESIGN.iconHeight"

          :label="$i18nPresenter.t(rightNavAllTabs.DESIGN.name)"
          :lang="getPresenterLocale"
        />
      </div>
    </div>
    <div :data-tab-name="rightNavAllTabs.AUDIO.name">
      <div class="aha-nav-button-container">
        <aha-nav-button
          class="w-full"
          :active="rightNavActiveTab === rightNavAllTabs.AUDIO.name"
          :disabled="isTabDisabled(rightNavAllTabs.AUDIO.name)"
          name="right_nav_button"
          v-aha-emit-action="{ user_input: rightNavAllTabs.AUDIO.name }"
          @click="activeTab(rightNavAllTabs.AUDIO.name)"
          :iconName="rightNavAllTabs.AUDIO.icon"
          :icon-width="rightNavAllTabs.AUDIO.iconWidth"
          :icon-height="rightNavAllTabs.AUDIO.iconHeight"

          :label="$i18nPresenter.t(rightNavAllTabs.AUDIO.name)"
          :lang="getPresenterLocale"
        />
      </div>
    </div>

    <div class="right-nav__divider-wrapper">
      <div class="right-nav__divider"></div>
    </div>

    <div :data-tab-name="rightNavAllTabs.SETTINGS.name">
      <div class="aha-nav-button-container">
        <aha-nav-button
          class="w-full"
          :active="rightNavActiveTab === rightNavAllTabs.SETTINGS.name"
          :disabled="isTabDisabled(rightNavAllTabs.SETTINGS.name)"
          name="right_nav_button"
          v-aha-emit-action="{ user_input: rightNavAllTabs.SETTINGS.name }"
          @click="activeTab(rightNavAllTabs.SETTINGS.name)"
          :iconName="rightNavAllTabs.SETTINGS.icon"
          :icon-width="rightNavAllTabs.SETTINGS.iconWidth"
          :icon-height="rightNavAllTabs.SETTINGS.iconHeight"

          :label="$i18nPresenter.t(rightNavAllTabs.SETTINGS.name)"
          :lang="getPresenterLocale"
        />
      </div>
    </div>
  </div>
</template>

<script>
// This component is a temporary solution for the Template Library in Editor
// (https://ahaslides.atlassian.net/browse/AHA-29321). It will be removed soon. Please do not use it.
//
// **Related Issue:**
// Template Library in Editor
// (https://ahaslides.atlassian.net/browse/AHA-29321)
//
// **Feature Flag:**
// release-template-library-in-editor
//
// **Removal Conditions:**
// - The refactor task is completed (https://ahaslides.atlassian.net/browse/AHA-29948).
//
// TODO: Remove this file once all the above conditions are met.

import RightNav from './RightNav.vue'
import TemplateLibraryNavButton from '@/components-v2/template-library/v2/TemplateLibraryNavButton.vue'

export default {
  components: {
    TemplateLibraryNavButton,
  },
  extends: RightNav,
}
</script>

<style lang="scss" scoped>
.aha-right-nav {
  @apply bg-base-0 h-full pt-4 overflow-y-auto text-secondary-100 border border-base-30;
  box-shadow: 0px 10px 38px 0px #525F7F14;
  width: 98px;
  min-width: 98px;
  z-index: 1;

  .aha-nav-button-container {
    @apply my-0 mx-1 mb-2;
  }

  .right-nav__divider-wrapper {
    @apply w-full my-3;
    .right-nav__divider {
      @apply bg-secondary-20 h-0.25 my-0 mx-auto;
      width: 40px;
    }
  }

  &.powerpoint-addin-sticky {
    position: fixed;
    right: 0;
    z-index: 2;
    overflow-x: hidden;
  }
}
</style>
